
import debounce from 'lodash/debounce';
import includes from 'lodash/includes';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import MediaLibraryActionBarUi from './action_bar_ui.jsx';
import { ALL_MEDIA_LIBRARY_ASSET_TYPES } from 'zoomforth_media_library/const.js';
import { getDisplayNameForAssetType } from 'zoomforth_media_library/lib/assets.js';
import MediaLibraryFolder from 'zoomforth_media_library/models/media_library_folder.js';

import { makeFormModal } from 'zoomforth_tools/make_form_modal.js';


class MediaLibraryActionBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // Query state lives here so that we can update input search quickly
      // while delaying actual searching briefly
      textSearch: props.navState.getTextSearch(),
      isMediaTypesDropdownActive: false,
      isExtraActiveCurrentFiltersDropdownShown: false
    };

    this.performQueryDebounced = debounce(()=> { this.performQuery(); }, 100);
    autobind(this);
  }

  componentDidMount() {
    this.props.navState.on('change', (navState)=> {

      if (navState.hasChanged('text_search')) {
        // If the text_search changed in navState model then we need
        // to explicitly read that from the model
        this.setState({
          textSearch: navState.getTextSearch()
        });
      } else {
        this.forceUpdate();
      }
      
    }, this);
  }

  componentWillUnmount() {
    this.props.navState.off(null, null, this);
  }

  handleAddFolderClick() {
    makeFormModal({
      title: 'Add Folder',
      highlight: true,
      inputs: [{
        key: 'Folder Name',
        name: 'folder_name',
        value: 'Untitled Folder'
      }]
    }).done((form)=> {

      const newFolder = new MediaLibraryFolder({
        name: form.folder_name,
        parent_id: this.props.navState.get('folder_id')
      });

      newFolder.save()

        .done(()=> {
          this.props.onFolderAdd(newFolder);
        });

    });

  }

  handleTextSearchChange(textSearch) {
    this.setState({
      textSearch: textSearch
    });
    this.performQueryDebounced();
  }

  performQuery() {
    this.props.navState.navigate({
      text_search: this.state.textSearch
    });
  }

  handleDeactivateMediaTypeSearch(mediaType) {
    this.props.navState.removeMediaTypeSearch(mediaType);
  }

  handleActivateMediaTypeSearch(mediaType) {
    this.props.navState.addMediaTypeSearch(mediaType);
  }

  render() {

    const { 
      textSearch, 
      isMediaTypesDropdownActive, 
      isExtraActiveCurrentFiltersDropdownShown 
    } = this.state;
    const { navState, shouldDeemphasizeUpload, onAddMediaClick } = this.props;

    const enabledAssetTypes = navState.enabledMediaTypes;
    const activeMediaTypes = navState.getMediaTypesSearch();
    const isInSearchMode = navState.getIsSearching();

    const assetTypeData = map(ALL_MEDIA_LIBRARY_ASSET_TYPES, (assetType)=> {
      const isActive = includes(activeMediaTypes, assetType);
      return ({
        type: assetType,
        isActive,
        isDisabled: !includes(enabledAssetTypes, assetType),
        title: getDisplayNameForAssetType(assetType)
      });
    });

    return (
      <MediaLibraryActionBarUi 
        assetTypeData={sortBy(assetTypeData, 'title')}
        isExtraActiveCurrentFiltersDropdownShown={isExtraActiveCurrentFiltersDropdownShown}
        isInSearchMode={isInSearchMode}
        isMediaTypesDropdownActive={isMediaTypesDropdownActive}
        shouldDeemphasizeUpload={shouldDeemphasizeUpload}
        textSearch={textSearch}
        onAddFolderClick={this.handleAddFolderClick}
        onAddMediaClick={onAddMediaClick}
        onExtraActiveCurrentFiltersDropdownShow={()=> { 
          this.setState({ isExtraActiveCurrentFiltersDropdownShown:true }); 
        }}
        onExtraActiveCurrentFiltersDropdownHide={()=> { 
          this.setState({ isExtraActiveCurrentFiltersDropdownShown:false }); 
        }}
        onTextSearchChange={this.handleTextSearchChange}
        onMediaTypeSearchActivate={this.handleActivateMediaTypeSearch}
        onMediaTypeSearchDeactivate={this.handleDeactivateMediaTypeSearch}
        onMediaTypesDropdownShow={()=> { this.setState({ isMediaTypesDropdownActive:true }); }}
        onMediaTypesDropdownHide={()=> { this.setState({ isMediaTypesDropdownActive:false }); }}
      />
    );

  }
}

MediaLibraryActionBar.propTypes = {
  navState: PropTypes.object.isRequired,
  shouldDeemphasizeUpload: PropTypes.bool,
  onAddMediaClick: PropTypes.func.isRequired,
  onFolderAdd: PropTypes.func.isRequired
};

export default MediaLibraryActionBar;